<template>
  <h2
    class="font-normal text-2xl leading-tight text-center font-book mb-6 xl:text-4xl"
  >
    <slot />
  </h2>
  <hr
    class="mb-6 border-black xl:mb-12"
  >
</template>

<script>
export default {
  name: 'PageSectionHeading',
};
</script>
